import { Tooltip, Chip, Box } from '@mui/material';

// Chip and dropdown option max width for truncation
export const CHIP_MAX_WIDTH = 280;
export const DROPDOWN_OPTION_MAX_WIDTH = 280;

export const renderTruncatedTags =
  (getLabel, maxWidth = CHIP_MAX_WIDTH) =>
  (selected, getTagProps) =>
    selected.map((option, index) => {
      const label = getLabel(option);
      const tagProps = getTagProps({ index });
      return (
        <Tooltip key={option.id} title={label} arrow>
          <span>
            <Chip
              {...tagProps}
              label={<Box sx={{ maxWidth, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>{label}</Box>}
              sx={{ maxWidth, flexShrink: 1 }}
            />
          </span>
        </Tooltip>
      );
    });
